import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";

export interface PostalCodeValidatorError {
  postalCode: true;
}

export const PostalCodeValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

  const REGEX_POSTAL_CODE = "^[0-9]{5}$"; // @@@
  const regexp = new RegExp(REGEX_POSTAL_CODE);
 return regexp.test(control.value)? null : { postalCode: true } as PostalCodeValidatorError;
};
